import { render, staticRenderFns } from "./PatientVideoCallRoom.vue?vue&type=template&id=6045904e&scoped=true&"
import script from "./PatientVideoCallRoom.vue?vue&type=script&lang=ts&"
export * from "./PatientVideoCallRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045904e",
  null
  
)

export default component.exports